import { useEffect } from 'react'

// Set to display warnings only once per component/prop pair
const _uniqWarns = new Set()

/**
 * @param componentName name of the component
 * @param deprecationMap key/value object with keys for deprecated props and optional value for replacement
 * @param props actual component props
 */
const useDeprecatedProps = (componentName: string, deprecationMap: any, props: any) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      for (const propName in deprecationMap) {
        const warnId = `${componentName}-${propName}`
        if (props && propName in props && !_uniqWarns.has(warnId)) {
          let deprecationMessage = `[AIRBUS-DS] ${componentName} '${propName}' prop is deprecated.`
          const replacementPropName = deprecationMap[propName]
          if (replacementPropName) {
            deprecationMessage += ` Use '${replacementPropName}' instead.`
          }
          _uniqWarns.add(warnId)
          console.warn(deprecationMessage)
        }
      }
    }

    return () => {}
  }, [componentName, deprecationMap, props])
}

export default useDeprecatedProps
